module.exports = __webpack_public_path__ + "modalOn-5d5f25914af85125cced4912eea8deab.png";